import React, { useEffect, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const slides = [{
  image: 'https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=1920&q=80',
  title: 'Your Dream Day',
  subtitle: 'Awaits at Gardendale Venue'
}, {
  image: 'https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?w=1920&q=80',
  title: 'Rustic Elegance',
  subtitle: 'In a Natural Setting'
}, {
  image: 'https://images.unsplash.com/photo-1478146896981-b80fe463b330?w=1920&q=80',
  title: 'Create Memories',
  subtitle: 'That Last Forever'
}];
export function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % slides.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + slides.length) % slides.length);
  };
  return <section className="relative h-screen w-full overflow-hidden" data-id="element-122">
      {/* Slides */}
      {slides.map((slide, index) => <div key={index} className={`absolute inset-0 transition-opacity duration-1000 ${index === currentSlide ? 'opacity-100' : 'opacity-0'}`} data-id="element-123">
          <img src={slide.image} alt={slide.title} className="w-full h-full object-cover" data-id="element-124" />
          <div className="absolute inset-0 bg-black/30" data-id="element-125" />
        </div>)}

      {/* Content Overlay */}
      <div className="absolute inset-0 flex items-center justify-center" data-id="element-126">
        <div className="text-center text-white px-4" data-id="element-127">
          <h2 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-serif font-bold mb-4" data-id="element-128">
            {slides[currentSlide].title}
          </h2>
          <p className="text-sm sm:text-base md:text-lg uppercase font-light mb-8" style={{
          letterSpacing: '5px'
        }} data-id="element-129">
            {slides[currentSlide].subtitle}
          </p>
          <a href="#contact" className="inline-block bg-white text-black px-8 py-4 text-sm tracking-widest hover:bg-gray-100 transition-colors" data-id="element-130">
            SCHEDULE A VISIT
          </a>
        </div>
      </div>

      {/* Navigation Arrows */}
      <button onClick={prevSlide} className="absolute left-4 sm:left-8 top-1/2 -translate-y-1/2 text-white hover:text-gray-200 transition-colors" aria-label="Previous slide" data-id="element-131">
        <ChevronLeftIcon className="w-10 h-10 sm:w-12 sm:h-12" data-id="element-132" />
      </button>
      <button onClick={nextSlide} className="absolute right-4 sm:right-8 top-1/2 -translate-y-1/2 text-white hover:text-gray-200 transition-colors" aria-label="Next slide" data-id="element-133">
        <ChevronRightIcon className="w-10 h-10 sm:w-12 sm:h-12" data-id="element-134" />
      </button>

      {/* Slide Indicators */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-3" data-id="element-135">
        {slides.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-2 h-2 rounded-full transition-all ${index === currentSlide ? 'bg-white w-8' : 'bg-white/50'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-136" />)}
      </div>
    </section>;
}